import React, { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import Link from 'components/commercetools-ui/atoms/link';
import { CtaCardText } from 'components/commercetools-ui/organisms/curated-slider/types';
import { trackCtaClick } from 'helpers/analytics/ga4Events';
import { cleanString } from 'helpers/utils/util';
export interface Props {
  classnames?: string;
  ctaText?: CtaCardText[];
  ctaCardTextFontweightClass?: string;
  ffidCurated?: string;
  sectionClass?: string;
  sectionName?: string;
  hideSection?: boolean;
}
const CuratedCtaCard: React.FC<Props> = ({
  classnames,
  ctaText,
  ctaCardTextFontweightClass,
  ffidCurated,
  sectionClass,
  sectionName,
  hideSection,
}) => {
  const { resolvedTheme = 'light' } = useTheme();
  const [themeColor, setThemeColor] = useState('');

  useEffect(() => {
    setThemeColor(resolvedTheme ?? '');
  }, [resolvedTheme]);

  if (sectionName == 'past-order' && !hideSection) {
    return;
  }

  const redirectionLink = sectionName === 'review-projects' ? '/my-project' : '/account/?hash=order-status';

  const url = sectionName === 'product-recommend' ? '/just-for-you' : redirectionLink;

  return (
    <div
      className={`flex items-center justify-center rounded-2xl ${sectionClass} ${classnames}`}
      data-ffid={`ctr-${cleanString(ffidCurated ?? '')}-curated-cta-card`}
    >
      <div className="text-center" data-ffid={`ctr-${cleanString(ffidCurated ?? '')}-card-content`}>
        <Link
          link={url}
          data-testid="headline-text"
          className={`block rounded-2xl border border-solid px-16 py-6 dark:text-black ${ctaCardTextFontweightClass}`}
          style={{
            background:
              themeColor === 'dark' ? `${ctaText?.[0]?.ctaTextBackColorDark}` : `${ctaText?.[0]?.ctaTextBackColor}`,
            color: themeColor === 'dark' ? `${ctaText?.[0]?.ctaTextColorDark}` : `${ctaText?.[0]?.ctaTextColor}`,
            fontSize: `${ctaText?.[0]?.ctaTextFontsize}px`,
            borderColor: `${ctaText?.[0]?.ctaTextColor}`,
          }}
          data-ffid={`btn-cta-${cleanString(ffidCurated ?? '')}-card-action`}
          onClick={() => {
            trackCtaClick(
              `${ffidCurated ?? 'curated'}-cta-card`,
              ctaText?.[0]?.ctaText ?? '',
              `${window.location.href}${url}`,
            );
          }}
        >
          {ctaText?.[0]?.ctaText}
        </Link>
      </div>
    </div>
  );
};

export default CuratedCtaCard;
